import { Component, OnInit } from '@angular/core';
import { CleverTapConstents } from 'src/app/services/constants';
import { BankDetails, TosterMsgType } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.scss']
})
export class BankDetailsComponent implements OnInit {


  showAggrigator: boolean = false;

  isAccountAggrigator: boolean = false;
  get currentApplicant() {
    return this.util.getCurrentApplicant;
  }

  get isAccountNumberMasked(): boolean {
    return !parseInt(this.activeAccount.accountNo) && this.isAccountAggrigator;
  }

  bankdetails: BankDetails[] = [];
  suggestedBanklist:any = [];
  confirmAccountnumer: any;

  errors:any = {
    ifsc: '',
    accountNo: '',
  }

  get isFormValidate() {
    try{
      const acc: BankDetails = this.activeAccount;
    if (!acc.accountNo.length || !(acc.isReadOnly?acc.bankName: acc.bankName.name).length || acc.ifsc.length < 11 || !acc.name.length || this.isAccountNumberMasked && !this.confirmAccountnumer?.length) {
      return false;
    }

    if (Object.values(this.errors).join('')) {
      return false;
    }
    return true;
    }catch(err){
      return false;
    }
  }

  get activeAccount(): BankDetails {
    return this.bankdetails[this.bankAcc] || {
      id: 0,
      accountId: '',
      name: '',
      accountNo: '',
      bankName: '',
      ifsc: '',
      bankConfirmation: false,
      isReadOnly: false,
      isIfscReadonly: false,
    };
  }

  get isMultiBank(): boolean {
    return this.isAccountAggrigator && this.currentApplicant.isSelfEmployed;
  };

  get isAccountConfirmed(): boolean {
    return this.bankdetails.every((d: BankDetails) => d.bankConfirmation);
  }

  constructor(public util: UtilService) {

  }

  ngOnInit(): void {
    
    // this.search();
    this.initBankPage();

    this.util.userLoggedInEventCalled.subscribe(()=>{
      this.initBankPage();
    })

if(this.isAccountAggrigator && this.util.isMobile){
  this.util.loaderService.show();
  setTimeout(() => {
    this.util.loaderService.hide();
  },3000);
}
   

  }

  initBankPage() {
    const loandata: any = this.util.loanDetails;
    this.util.setCache('kycTab', 'bank');
    if(!loandata){
      return;
    }
    this.isAccountAggrigator = !loandata.loanCommercialDetails.length;
    if(this.isAccountAggrigator){
      setTimeout(() => {
         (<any>document.querySelector('#confirmAccountnumer'))?.focus();
      },100);
    }
    this.getBankDetails();
  }

  getBankDetails() {
    this.bankdetails = [...this.currentApplicant.loanBankConnectAccountsInfo?.map((ac: any) => { return { ...ac ,isIfscReadonly: ac.ifsc ,isReadOnly: true }; })];
    if (!this.bankdetails) {
      this.bankdetails = [];
    }
    this.showAggrigator = this.bankdetails.length <= 0 && this.isAccountAggrigator;

    if (this.bankdetails.length) {
      this.bankAcc = this.bankdetails.findIndex((account: BankDetails) => !account.bankConfirmation);
      if (this.bankAcc === -1) {
        this.bankAcc = 0;
      }
    }


    if (!this.bankdetails.length) {
      this.bankdetails = [
        {
          id: 0,
          accountId: '',
          name: '',
          accountNo: '',
          bankName: '',
          ifsc: '',
          bankConfirmation: false,
          isReadOnly: false,
          isIfscReadonly:false,
        }
      ];
    }



  }

  bankAcc: number = 0;
  discardDialog: boolean = false;

  showDialog() {
    this.discardDialog = true;
  }

  getBankConnectUpload(entityId: string) {
    this.showAggrigator = false;
    this.confirmAccountnumer = '';
    this.util.handleRequests('get', this.util.getUrl('loan_bankconnect_upload', [this.util.loanDetails.loanId, entityId, this.util.getCurrentApplicant.id])).then((res: any) => {
      if (!res.content || !Object.keys(res.content).length) {
        this.util.showToaster('Unexpected error with bank response', TosterMsgType.ERROR);
      } else
        if (res.status == "SUCCESS") {
          this.util.cleverTapEventCall(CleverTapConstents.mode_section_on_bank_statement,{
            'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
          'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
          });
          this.util.getProducts().then(() => {

            this.initBankPage();
          });
        } else {
          this.util.route('home');
        }
    }, (err: any) => {
      this.util.route('home');
    })
  }

  confirmBankData() {
    const body =
      this.activeAccount.accountId ? {
        loanId: this.util.loanDetails.loanId,
        ifsc: this.activeAccount.ifsc,
        accountId: this.activeAccount.accountId,
        accountNumber: this.isAccountNumberMasked ? this.confirmAccountnumer : this.activeAccount.accountNo,
      }
        :
        {
          'loanId': this.util.loanDetails.loanId,
          'ifsc': this.activeAccount.ifsc,
          'applicantId': this.util.getCurrentApplicant.id,
          'accountNo': this.isAccountNumberMasked ? this.confirmAccountnumer : this.activeAccount.accountNo,
          'name': this.activeAccount.name,
          'npciBankName': this.activeAccount.bankName.name
        };
    this.activeAccount.accountId ? this.updateFinboxDetails(body) : this.manualBankDetails(body);
  }

  manualBankDetails(body: any) {
    this.util.handleRequests('post', this.util.getUrl('loan_save_bank'), body).then((res: any) => {
      if (res.status === 'SUCCESS') {
        this.confirmBank();
      } else {
        this.util.showToaster('Please try Again', TosterMsgType.ERROR);
      }
    });
  }


  updateFinboxDetails(body: any) {
    this.util.handleRequests('put', this.util.getUrl('loan_bankconnect_update', ([this.util.getCurrentApplicant.id])), body).then(() => {
      this.util.handleRequests('put', this.util.getUrl('loan_bankconnect_confirm', [this.util.getCurrentApplicant.id]), {
        loanId: this.util.loanDetails.loanId,
        accountId: this.activeAccount.accountId,
      }).then(() => {

        this.util.cleverTapEventCall(CleverTapConstents.bank_details_verifi,{
          'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
          'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
        });
        if (this.isMultiBank && !this.activeAccount.bankConfirmation) {
          this.util.getProducts().then(() => {

            this.initBankPage();
          })
        } else {
          this.confirmBank();
        }



      });
    });
  }

  confirmBank() {
    this.util.handleRequests('put', this.util.getUrl('loan_confirm_bank', [this.util.loanDetails.loanId, this.util.getCurrentApplicant.id])).then(() => {
      this.util.getProducts().then(() => {

        this.initBankPage();
        // console.log('bank component')
        // if(this.util.loanDetails.hasMoratorium){
        //   this.util.route('moratorium')
        // }
        //  else 
         if (this.isAccountAggrigator) {
          this.util.route('eligibility');
        } else
          this.util.navigationHandler();
      })
    });
  }

  async submit() {
    try {
      const res = await this.util.handleRequests('get', this.util.getUrl('loan_validate_ifsc', [this.activeAccount.ifsc]), undefined, undefined, undefined, false);

      if (res.status === 'SUCCESS') {
        this.confirmBankData();
      } else {
        this.errors.ifsc = 'Invalid IFSC code.';
      }



    } catch (err: any) {
      this.errors.ifsc = err.msg;

    }
  }


  validateAccountNumber(ev: any, isConfirmAccNo: boolean = false) {
    if (isConfirmAccNo) {
      if (this.isAccountNumberMasked) {
        const maskedAccountNumber = this.activeAccount.accountNo ?? '';

        this.errors.accountNo = ev.target.value.length == maskedAccountNumber.length && maskedAccountNumber.substr(-4) === ev.target.value.substr(-4) ? '' : 'Invalid account number';

      }
    } else {
      if (ev.target.value.length < 8) {
        this.errors.accountNo = 'Invalid account number';
      } else {
        this.errors.accountNo = '';
      }
    }

  }

  removeBackAccount() {
    this.util.handleRequests('delete', this.util.getUrl('loan_remove_bank', [this.util.loanDetails.loanId, this.activeAccount.accountId])).then((res: any) => {
      if (res.status === 'SUCCESS') {
        this.util.cleverTapEventCall("Discard application",{
          'loanId':this.util.loanDetails.loanId
        })
        this.discardDialog = false;
        this.util.getProducts().then(() => {
          this.initBankPage();
        })
      }
    })
  }
  addAccount() {
    this.showAggrigator = true;
  }

  search(event:any, d:any){
    this.errors.bankName = "";

       const query = event.query;
       if(!query && this.suggestedBanklist.length){
        d.show();
        return;
       }
      this.util.handleRequests('get', this.util.getUrl('loan_bankList', [0,query]),undefined,undefined,undefined,undefined,false).then((res:any)=>{

      const list = [...(res.popularBanks ?? []) ,...(res.bankList?? [])];

      this.suggestedBanklist = query? (res.bankList?? []): list;

      if(!this.suggestedBanklist.length){
        this.errors.bankName = "Bank not found. Please contact your RM.";
      }


    })
  }
  resetErros(target:string){
  this.errors[target] = '';
  }

}
